export const downloadBlob = (data: Blob, fileName = '') => {
    const link = document.createElement('a');

    link.style.display = 'none';

    link.href = window.URL.createObjectURL(
        new Blob([data])
    );

    link.setAttribute('download', fileName || 'report');

    document.body.appendChild(link);
    link.click();

    URL.revokeObjectURL(link.href);
};
